import list_ApiUrl from '../compartida/listApiUrl';

export default {
  login: function (data) {
    return axios.post(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.API_URL_LOGIN, {
      "email": data.correo,
      "password": data.contrasena
    },{headers: {
      Accept: "application/json",
        "Access-Control-Allow-Origin": "http://localhost:8080",
        "Access-Control-Request-Headers":"access-control-allow-origin,content-type"
    }});
  },
  isLogueado: function () {
    if (localStorage.getItem('tok_header1') && localStorage.getItem('toke_id'))
      return true;
  },
  logout: function () {
    localStorage.removeItem('tok_header1');
    localStorage.removeItem('tok_header2');
    localStorage.removeItem('toke_id');
    if (!this.isLogueado())
      window.location.href = "/login";
  }
};



// WEBPACK FOOTER //
// ./src/components/auth/auth.Service.js